var map = {
	"./_next.png": 1336,
	"./_prev.png": 1337,
	"./agpaginationbtn/btFirst.svg": 1338,
	"./agpaginationbtn/btLast.svg": 1339,
	"./agpaginationbtn/btNext.svg": 1340,
	"./agpaginationbtn/btPrevious.svg": 1341,
	"./bed-outline.png": 1342,
	"./c5.jpg": 1343,
	"./c6.jpg": 859,
	"./c7.jpg": 1344,
	"./c9.jpg": 1345,
	"./calendar-outline.png": 1346,
	"./calendar-outline1.png": 262,
	"./calendar.png": 858,
	"./caro3.jpg": 1347,
	"./caro7.jpg": 1348,
	"./caro8.jpg": 1349,
	"./check.png": 889,
	"./close_icon.png": 575,
	"./cloud-computing.png": 619,
	"./defaultRoom.png": 1350,
	"./defaultRoomImg.png": 1351,
	"./details.png": 1352,
	"./dropcloseicon.png": 863,
	"./dropcloseicon1.png": 1353,
	"./guesthouse.jpg": 1354,
	"./happy.png": 891,
	"./hero-banner1.png": 932,
	"./highlights_tick.png": 541,
	"./homestay.png": 1355,
	"./hotel.png": 265,
	"./imageIcon.png": 1356,
	"./location.png": 1357,
	"./location1.png": 864,
	"./loginIcon.png": 1358,
	"./next.png": 861,
	"./no-icon.png": 1359,
	"./no-icon1.png": 91,
	"./no-picture.jpg": 375,
	"./pencilColor.png": 867,
	"./people-outline.png": 1360,
	"./people-outline1.png": 865,
	"./pls.png": 656,
	"./prev.png": 860,
	"./profile-back.png": 603,
	"./qr-code.png": 1361,
	"./resetIcon.png": 1362,
	"./searchicon.png": 1363,
	"./searchicon1.png": 620,
	"./shield.png": 1364,
	"./smartphone1.png": 1365,
	"./smartphone2.png": 1366,
	"./stateLoaderImage.png": 353,
	"./staticmap.png": 873,
	"./staying-pic-arunachal.png": 1367,
	"./staying-pic-meghalaya.png": 1368,
	"./staying-pic-odisha.png": 1369,
	"./staying-pic-sikkim.png": 1370,
	"./staying-pic-tamil-nadu.png": 1371,
	"./staying-pic-west-bengal.png": 1372,
	"./stayingLogo.png": 580,
	"./stayingLogoNew.png": 539,
	"./stayingLogoWhite.png": 588,
	"./tickicon.png": 1373,
	"./toastify/bell.png": 892,
	"./toastify/error.png": 1374,
	"./toastify/errorimg.png": 893,
	"./toastify/info.png": 894,
	"./toastify/information.png": 895,
	"./toastify/success.png": 1375,
	"./toastify/successimg.png": 896,
	"./toastify/warning.png": 1376,
	"./toastify/warnningIcon.png": 897,
	"./trendingImg1.png": 930,
	"./trendingImg2.png": 1377,
	"./trendingImg3.png": 1378,
	"./trendingImg4.png": 1379,
	"./trendingImg5.png": 1380,
	"./trendingImg6.png": 1381,
	"./trendingImg7.png": 1382,
	"./unapprovedicon.png": 1383,
	"./updateIcon.png": 868,
	"./uploadFile.png": 1384,
	"./usericon.png": 855,
	"./vietnam.jpg": 1385,
	"./warning.png": 1386,
	"./zoom-in.png": 578,
	"./zoom-out.png": 579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 264;